export default class EventVerifyCode {
	static Invalid = 0;
	static NoAssetID = 1;
	static NoFilePath = 2;
	static PlayerLoadError = 4;
	static NotActive = 8;
	static InvalidStartDate = 16;
	static InvalidEndDate = 32;
	static InvalidKillDate = 64;
	static NoGeneratedFilePath = 128;
	static InvalidAssetReleaseDate = 256;
	static InvalidAssetEndDate = 512;
	static InvalidExecuteCommandType = 1024;
	static OverlappingShowEvent = 2048;
	static ShowEventStartTimePushedBack = 4096;
	static PoiMarkerPriorToTrimIn = 8192;
	static HourRestrictions = 16384;
}